"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var BaseQuery_1 = require("./BaseQuery");

var Query_1 = require("./Query");

var ObjectQuery =
/** @class */
function (_super) {
  __extends(ObjectQuery, _super);

  function ObjectQuery() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  ObjectQuery.prototype.getOptions = function () {
    var _a = this.queryOptions,
        fields = _a.fields,
        _b = _a.options,
        options = _b === void 0 ? {} : _b;
    return __assign({
      fields: fields
    }, options.object || {});
  };

  ObjectQuery.prototype.getRawValue = function (executionOptions) {
    var fields = this.queryOptions.fields;
    var response = {};

    for (var _i = 0, fields_1 = fields; _i < fields_1.length; _i++) {
      var field = fields_1[_i];
      var name_1 = field.name,
          query = field.query;

      if (query) {
        var valueQuery = new Query_1.Query(query);
        var value = valueQuery.execute(executionOptions);
        response[name_1] = value;
      }
    }

    return response;
  };

  return ObjectQuery;
}(BaseQuery_1.BaseQuery);

exports.ObjectQuery = ObjectQuery;